var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-chart flex justify-center relative"},[_c('div',{ref:"charts",staticClass:"w-chart h-full"}),(_vm.source.length === 0)?_c('div',{staticClass:"w-full h-full absolute left-0 top-0 z-10 flex flex-col items-center justify-center bg-white"},[_c('el-empty',{attrs:{"image-size":260,"description":"暂无图例"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }